<template>
  <v-dialog
    max-width="500"
    v-model="modal">
    <template v-slot:default="dialog">
      <v-card
        class="rounded-lg d-flex flex-column"
        style="min-height: 300px;">
        <v-card-title
          class="pt-9 px-12">
          <v-row
            class="text-center d-flex justify-start">
            <span
              class="text-h6 font-weight-bold primary--text">
              Detalhes da movimentação
            </span>
            <v-spacer />
            <v-icon
              size="25"
              color="muted-accent"
              @click="close">
              close
            </v-icon>
          </v-row>
        </v-card-title>
        <v-card-text
          class="px-9 pt-5 d-flex flex-column flex-grow-1">
          <p
            class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
            Data/hora da criação da movimentação
          </p>
          <p
            class="pb-0 text-body-2 mb-3">
            {{ formatter.formatDateTimeZoneWithHours(movementDetails.movementDate) }}
            {{ movementDetails.userName ? `por ${movementDetails.userName}` : '' }}
          </p>

          <div
            v-if="Boolean(movementDetails && movementDetails.releasedAt)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data/hora da liberação da movimentação
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDateTimeZoneWithHours(movementDetails.releasedAt) }}
              {{ movementDetails.releaseUser ? `por ${movementDetails.releaseUser}` : '' }}
            </p>
          </div>

          <div
            v-if="Boolean(movementDetails && movementDetails.sendAt)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data/hora de envio para a operadora
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDateTimeZoneWithHours(movementDetails.sendAt) }}
              {{ movementDetails.sendUser ? `por ${movementDetails.sendUser}` : '' }}
            </p>
          </div>

          <div
            v-if="Boolean(movementDetails && movementDetails.movementInsuranceCarrierId)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Nº do lote de envio da operadora
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ movementDetails.movementInsuranceCarrierId }}
            </p>
          </div>

          <div
            v-if="
              Boolean(movementDetails && movementDetails.dateFinish)
              && ['SUCCESS', 'FINISH_WITH_CRITICAL'].some(status => movementDetails.status === status)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data/hora da finalização da movimentação
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDateTimeZoneWithHours(movementDetails.dateFinish) }}
              {{ movementDetails.userFinish
                ? `por ${movementDetails.userFinish}`
                  : movementDetails.userForceFinish
                  ? `por ${movementDetails.userForceFinish}`
                : ''
              }}
            </p>
            <p>
              <b v-if="isBackoffice">
                {{ movementDetails.finishProcess
                  ? `Finalização: ${getFinishProcess(movementDetails.finishProcess)}`
                  : ''
                }}
              </b>
            </p>
          </div>
          <div
            v-if="Boolean(movementDetails && movementDetails.dateCancellation)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data/hora do cancelamento da movimentação
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDateTimeZoneWithHours(movementDetails.dateCancellation) }}
              {{ movementDetails.userCancellation ? `por ${movementDetails.userCancellation}` : '' }}
            </p>
          </div>

          <div
            v-if="Boolean(movementDetails && movementDetails.reasonCancellation)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Motivo do cancelamento
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ movementDetails.reasonCancellation ? movementDetails.reasonCancellation : '-' }}
            </p>
          </div>

          <div
            v-if="Boolean(movementDetails && movementDetails.coverageExtensionReason)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Motivo de permanência
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.capitalizeText(getCoverageDescriptionById(movementDetails.coverageExtensionReason)) }}
            </p>
          </div>

          <div
            v-if="Boolean(movementDetails && movementDetails.coverageExtensionLimitDate)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data limite
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ moment(movementDetails.coverageExtensionLimitDate, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
            </p>
          </div>
          <div
            v-if="Boolean(movementDetails && ((movementDetails.helpdeskTickets && movementDetails.helpdeskTickets.length > 0) || movementDetails.helpdeskId))">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              {{ helpdeskLabel }}
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              <HelpdeskTicketsCell
                :helpdesk-tickets="movementDetails.helpdeskTickets"
                :helpdesk-id="movementDetails.helpdeskId"
              />
            </p>
          </div>
        </v-card-text>
        <v-card-actions
          class="px-9 pb-9">
          <v-row
            no-gutters>
            <v-spacer />
            <v-btn
              class="text-body-2 elevation-0 primary--text"
              height="40"
              color="muted-foreground"
              @click="close">
              <v-icon
                left>
                fas fa-arrow-left
              </v-icon>
              Fechar
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import CoverageMixin from '@/shared/mixins/coverage/coverageMixin';
import Formatters from '@/shared/formatters/formatters';
import HelpdeskTicketsCell from '@/components/Default/HelpdeskTicketsCell.vue';
import moment from 'moment';

export default {
  name: 'MovementDetailModal',

  components: {
    HelpdeskTicketsCell,
  },

  data: () => ({
    moment,
    modal: false,
    formatter: null,
    movementDetails: null,
    coverages: [],
    isRHProtegido: null,
  }),

  mixins: [
    CoverageMixin,
  ],

  methods: {
    open(item) {
      this.movementDetails = item;
      this.modal = true;
    },
    close() {
      this.modal = false;
      this.movementDetails = false;
    },
    getFinishProcess(process) {
      if (process === 'MANUAL') return 'Manual';
      if (process === 'IMPLANTATION') return 'Carga de Base';
      if (process === 'CADASTRAL_POSITION') return 'Posição Cadastral';
      if (process === 'API') return 'Automática';
      return '';
    },
  },

  computed: {
    helpdeskLabel() {
      const tickets = this.movementDetails?.helpdeskTickets;
      const ticketsCount = Array.isArray(tickets) ? tickets.length : 0;

      return ticketsCount > 1 ? 'Nº dos atendimentos' : 'Nº do atendimento';
    },
    isRHProtegidoBool() {
    // 1) Tenta via router
      let raw = this.$route?.query?.isRHProtegido;

      // 2) Fallback: URL do documento (dentro do iframe)
      if (raw === undefined || raw === null) {
        raw = new URLSearchParams(window.location.search).get('isRHProtegido');
      }

      if (raw === undefined || raw === null) return null;

      const str = String(raw).trim().toLowerCase();
      if (['true', '1', 'yes', 'y'].includes(str)) return true;
      if (['false', '0', 'no', 'n'].includes(str)) return false;
      return null; // valor inesperado
    },
    isBackoffice() {
    // backoffice quando explicitamente false
      return this.isRHProtegidoBool === false;
    },
  },

  created() {
    this.formatter = new Formatters();
    this.isRHProtegido = this.$route.query.isRHProtegido;
  },

  async beforeMount() {
    await this.fetchCoverages()
      .then((result) => this.coverages = result)
      .catch((error) => this.$emit('showError', 'Erro na busca pelos motivos de permanência'));
  },
};
</script>
